import auth from './auth';
import bank from './bank';
import common from './common';
import dashboard from './dashboard';
import edo from './edo';
import profile from './profile';
import warehouses from './warehouses';
const ru = {
   ...auth,
   ...bank,
   ...dashboard,
   ...common,
   ...warehouses,
   ...edo,
   ...profile,
};
export default ru;
